<template>
  <div class="deposito-pay-popup">
    <van-nav-bar title="Depósito" left-arrow @click-left="onClickLeft"></van-nav-bar>

    <div class="pay-bg">
      <img src="/theme/pay/pay-bg.png" alt="logo" class="pay-bg-img" />
      <div class="pay-overlay">
        <div class="chxy-column-c-c pay-content">
          <div class="payment-amount-label">Importe del pago:</div>
          <div class="payment-amount-value">
            MX$ {{ formatNumberWithComma(filterAmount(props.payInfo.amount) || '0.00') }}
          </div>
        </div>
      </div>
    </div>

    <div
      class="chxy-row-bt payment-info-container"
      @click="clickCopyPublic(props.payInfo?.needInfo.accountNumber)"
    >
      <div class="clabe-container">
        <div class="clabe-label">Clabe:</div>
        <div class="clabe-value">
          {{ props.payInfo?.needInfo.accountNumber || '-' }}
        </div>
      </div>
      <div class="copy-button chxy-row-c-c">
        <div class="copy-text">Copiar</div>
      </div>
    </div>

    <div
      class="chxy-row-bt payment-info-container"
      @click="clickCopyPublic(props.payInfo?.needInfo.bankName)"
    >
      <div class="clabe-container">
        <div class="clabe-label">Banco Destino:</div>
        <div class="clabe-value">
          {{ props.payInfo?.needInfo.bankName || '-' }}
        </div>
      </div>
      <div class="copy-button chxy-row-c-c">
        <div class="copy-text">Copiar</div>
      </div>
    </div>

    <div class="chxy-row-bt payment-info-container m-b-5">
      <div class="clabe-container">
        <div class="clabe-label">Beneficiario:</div>
        <div class="clabe-value">{{ props.payInfo?.needInfo.accountName || '-' }}</div>
      </div>
    </div>

    <!-- 临时写，要改成数组 循环 -->
    <div class="instruction-step chxy-row-ac">
      <img src="/theme/pay/pay-copy-fff.png" alt="logo" class="instruction-icon" />
      <div class="instruction-text">
        <div class="instruction-step-label">Paso 1:</div>
        <div class="instruction-step-value">Copiar la Clabe</div>
      </div>
    </div>
    <div class="instruction-step chxy-row-ac">
      <img src="/theme/pay/pay-card.png" alt="logo" class="instruction-icon" />
      <div class="instruction-text">
        <div class="instruction-step-label">Paso 2:</div>
        <div class="instruction-step-value">
          Pegar la Clabe en su App bancaria e ingresar el monto a pagar.
        </div>
      </div>
    </div>
    <div class="instruction-step chxy-row-ac">
      <img src="/theme/pay/read-book.png" alt="logo" class="instruction-icon" />
      <div class="instruction-text">
        <div class="instruction-step-label">Paso 3:</div>
        <div class="instruction-step-value">
          Revisar que el importe sea descontado de su saldo. (Si este no es confirmado de inmediato,
          revisar más tarde)
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { formatNumberWithComma } from '@/utils/format.js'
// import { langEnums } from '@/utils/i18n'
// const { t, locale } = useI18n()

const props = defineProps({
  payInfo: {
    type: Object,
    default: () => ({}),
  },
})

const onClickLeft = () => {
  emit('mx-close')
}

const clickCopyPublic = async (text) => {
  try {
    await navigator.clipboard.writeText(text)
    showToast(t('deposito-pay.copiedSuccess'))
  } catch (error) {
    console.log('error ----- ', error)
  }
}

// 充值金额过滤
const filterAmount = (amount) => {
  // 分转元
  const newAmount = amount / 100
  return newAmount.toFixed(2)
}

const filterQcdoeNumShow = (value) => {
  if (value && value.length > 8) {
    // 切割当前字符串的最后8位数
    return '**' + value.substring(value.length - 8, value.length - 1)
  }
  return '*******'
}

const emit = defineEmits(['mx-close'])
</script>

<style lang="scss" scoped>
// 墨西哥暂时 固定 绿色 + 黑色 + 白色 配套  后续再支持动态  每次发原创注意下颜色
.van-nav-bar {
  --van-nav-bar-background: #212227 !important;
  --van-nav-bar-icon-color: #fff !important;
  --van-nav-bar-text-color: #fff !important;
  --van-nav-bar-title-text-color: #fff;
}
.deposito-pay-popup {
  background: #212227; //var(--deposito-view-bg);
  overflow-y: scroll;
  height: 100vh;
  .pay-bg {
    width: 375px;
    height: 119px;
    position: relative;
  }

  .pay-overlay {
    position: absolute;
    top: 0;
    left: 0;
    font-size: 12px;
    width: 100%;
    height: 100%;
    color: #000;
  }

  .pay-content {
    height: 100%;
  }

  .payment-amount-label {
    font-size: 14px;
    color: #383838;
    font-weight: bold;
  }

  .payment-amount-value {
    font-weight: 900;
    font-size: 28px;
    color: #383838;
  }

  .payment-info-container {
    position: relative;
    width: 375px;
    margin-top: 20px;
    height: 38px;
    padding: 10px;
  }

  .clabe-container {
    div:first-child {
      font-size: 12px;
      color: #a4a7aa;
    }

    div:last-child {
      font-size: 14px;
      color: #fff;
    }
  }

  .copy-button {
    width: 78px;
    position: relative;
    height: 28px;
    background: linear-gradient(130deg, #8bffc0 0%, #9aea73 100%);
    border-radius: 18px;
    padding: 5px 10px;
  }

  .copy-icon {
    width: 12px;
    height: 12px;
    margin-right: 5px;
  }

  .copy-text {
    font-size: 12px;
    color: #000;
  }

  .instruction-step {
    width: 355px;
    background: #2b2d34;
    border-radius: 8px;
    margin: 10px;
    padding: 10px 0;
  }

  .instruction-icon {
    margin-left: 16px;
    width: 16px;
    height: 16px;
    margin-right: 10px;
  }

  .instruction-text {
    .instruction-step-label {
      color: #a4a7aa;
      font-size: 12px;
    }

    .instruction-step-value {
      color: #fff;
      font-size: 12px;
    }
  }
}
</style>
